export function debouncePromise<T>(fn: (args: any) => T, time: number) {
  let timerId: NodeJS.Timeout | undefined = undefined;

  return function debounced(...args: any[]){
    if (timerId) {
      clearTimeout(timerId);
    }

    return new Promise<T>((resolve) => {
      timerId = setTimeout(() => resolve(fn(...args)), time);
    });
  };
}
